import { capitalize } from "@mui/material";
import { Statusable } from "models/BO/BoUser";

export enum GroupStatus {
  active = 0
}


export enum GroupType {
  Inclusive = 0,
  Exclusive = 1,
}

export class Group implements Statusable {
  id: string;
  name: string;
  description: string;
  statusId: number;
  type: number;
  created: Date;

  get status(): string {
    return this.statusId?.toString();
  }

  get statusLabel(): string {
    return capitalize(GroupStatus[this.statusId]);
  }

  get statusColor(): string {
    return this.statusId == GroupStatus.active ? "success" : "error";
  }

  get statuses(): { key: string; value: string }[] {
    return Object.keys(GroupStatus)
      .filter((key) => !isNaN(Number(key)))
      .map((key) => ({
        key: key,
        value: capitalize(GroupStatus[key]),
      }));
  }
}
